import {Session, useSessionSalesInsights} from "../../../../features/sessions";
import {GetSessionApiResponse} from "../../../../react-query-hooks/session/types/edit-session";
import {SessionCustomerInsights} from "./customers-section";
import {RevenueSection} from "./revenue-section";

type TSalesAndInsights =
  | {session: Session; sessionData?: never}
  | {session?: never; sessionData: GetSessionApiResponse};

export function SalesAndInsights(props: TSalesAndInsights) {
  // Extract common properties from either Session entity or legacy sessionData
  const sessionId = props.session?.id ?? props.sessionData?.id ?? 0;
  const callDuration =
    props.session?.callDuration ?? props.sessionData?.callDuration ?? 0;

  const salesInsightsQuery = useSessionSalesInsights(sessionId);

  return (
    <div>
      <RevenueSection
        salesInsights={salesInsightsQuery.data}
        isLoadingSalesInsights={salesInsightsQuery.isLoading}
      />
      <SessionCustomerInsights
        sessionId={sessionId}
        date={""}
        duration={callDuration}
        startTime={""}
      />
    </div>
  );
}
